import { PadlockLockedFillIcon } from "@navikt/aksel-icons";
import React from "react";
export const ReadOnlyIcon = ({ readOnly, nativeReadOnly = true, }) => {
    if (readOnly) {
        return (React.createElement(PadlockLockedFillIcon, Object.assign({}, (nativeReadOnly ? { "aria-hidden": true } : { title: "readonly" }), { className: "navds-form-field__readonly-icon" })));
    }
    return null;
};
//# sourceMappingURL=ReadOnlyIcon.js.map